import React, { useEffect, useRef, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import errorHandler from '../../utils/errorHandler';
import ApiService from "../../services/categoryManagementApi";

const { NotificatiopnApi } = ApiService;

const NotificationView = ({ data, setData }) => {
    const [notificationdata, setNotificationData] = useState();
    const ref = useRef(null);
    const isSubmitting = false; // You can replace this with actual state if needed

    const handleClose = () => {
        setData({ open: false, id: "" });
    };

    useEffect(() => {
        const getData = async () => {
            try {
                const res = await NotificatiopnApi.getOneNotificationTemplate(data?.id);
                setNotificationData(res?.data?.data);
            } catch (error) {
                errorHandler(error);
            }
        };

        if (data?.id) {
            getData();
        }
    }, [data]);

    return (
        <Dialog
            open={data.open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            ref={ref}
        >
            <DialogContent>
                <Typography variant="h4">Send Notification</Typography>
                <hr />

                <Typography sx={{ fontWeight: "bold", marginTop: "24px" }}>Title (English)</Typography>
                <Typography id="alert-dialog-description">
                    {notificationdata?.title || "N/A"}
                </Typography>


                <Typography sx={{ fontWeight: "bold", marginTop: "24px" }}>Title (Khmer)</Typography>
                <Typography id="alert-dialog-description">
                    {notificationdata?.titleKh || "N/A"}
                </Typography>

                <Typography sx={{ fontWeight: "bold", marginTop: "18px" }}>Content (English)</Typography>
                <Typography id="alert-dialog-description">
                    {notificationdata?.content || "N/A"}
                </Typography>

                 <Typography sx={{ fontWeight: "bold", marginTop: "18px" }}>Content (Khmer)</Typography>
                <Typography id="alert-dialog-description">
                    {notificationdata?.contentKh || "N/A"}
                </Typography>

                <DialogActions sx={{ paddingRight: 0, paddingTop: "15px" }}>
                    <Button variant="outlined" onClick={handleClose} disabled={isSubmitting}>
                        Close
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default NotificationView;
